/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */

/*
 * IMPORT POLYFILLS
 *
 * we need to check in the end what we need
 *
 */

/*
import 'core-js/features/object/assign';
import 'core-js/features/object/keys';
import 'core-js/features/array/includes';
import 'core-js/features/dom-collections/for-each';
import 'classlist-polyfill';
*/

import 'core-js/features/promise';
import 'whatwg-fetch';
import 'intersection-observer';
import 'svg-innerhtml-polyfill';
import 'classlist-polyfill';

/*
 * IMPORT STYLES
 */

import './scss/main.scss';

/*
 * LOCAL IMPORTS
 */

import { Logger, setLogLevel } from './logger';
import touchDetect from './touch-detect';
import iframeDetect from './iframe-detect';
import featureDetect from './feature-detect';
import { getNode } from './utils';
import { setLanguage, setTranslations } from './language';
import { setColors } from './colors';

/*
 * MAIN CLASS
 *
 * to be used as a singleton
 */

class TsgGraphics {
  constructor(params) {
    this.log = new Logger('tsg_main');
    this.log.debug('started');

    this.touchDetect = touchDetect;
    this.iframeDetect = iframeDetect;
    this.setLogLevel = setLogLevel;

    this.params = params || {};
    this.setLanguage();

    window.addEventListener('DOMContentLoaded', () => {
      if (window.EUROVIZ_OPTIONS) {
        this.setOptions(window.EUROVIZ_OPTIONS);
        this.createChart();
      }
    });
  }

  setOptions(params) {
    this.params = { ...this.params, ...params };
    this.setLanguage();
    this.setTranslations(this.params.translations);
    this.setColors(this.params.colors);
  }

  setLanguage(l) {
    setLanguage(l || this.params.language || 'en');
  }

  setColors(cs) {
    setColors(cs || {});
  }

  setTranslations(ts) {
    setTranslations(ts || {});
  }

  async createChart(params) {
    await Promise.all([iframeDetect.checkFixedHeight()]);

    if (params) this.setOptions(params);
    const containerOuter = getNode(`#${this.params.containerId}`);
    let container = containerOuter.querySelector('.tsg-container-embed');
    if (!container) {
      container = document.createElement('div');
      container.classList.add('tsg-container-direct');
      containerOuter.appendChild(container);
    }
    const chart = await import(/* webpackChunkName:"[request]" */`./charts/${this.params.graphicId}`);
    const create = chart.default;

    if (params) this.setOptions(params);
    create(container, this.params.options);
  }
}

/*
 * MAIN CODE
 */

if (!window.tsgGraphicsWG) {
  touchDetect.start(document.documentElement);
  iframeDetect.start(document.documentElement);
  featureDetect.start(document.documentElement);
  setLogLevel('ERROR');

  const tsgGraphicsWG = new TsgGraphics();
  window.tsgGraphicsWG = tsgGraphicsWG;

  window.dispatchEvent(new CustomEvent('tsg-wg-load'));
}

